export default "__VITE_ASSET__Ch4RSG44__"